import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=239b9636&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=ts&"
export * from "./PasswordReset.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=239b9636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239b9636",
  null
  
)

export default component.exports